import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Tooltip, Button, Modal, Icon } from "antd";
import { getBreadCrumbs, getWithDrawer, getNewPermission } from "../../utils";
import { injectIntl, FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { resumeDownload } from "../../actions/DownloadAction";
import {
  setActiveView,
  unsetSelectItem,
  handleOrderBy,
  handlePaginationNumber,
  activateMutipleSelectFunctions,
  multipleOptionsIsDone
} from "../../actions/ClientAction";
import { navigatePublicSharedFolder } from "../../actions/AssetsPublicSharedAction";
import CRUDFolder from "../folder/CRUDFolder";
import { setSelectedFolderExplore } from "../../actions/AppAction";
import { getBreadCrumbsByClient } from "../../actions/ClientAction";
import CloseIcon from "../../assets/fi_x-circle.svg";
const ButtonGroup = Button.Group;

export class CollectionHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      breadcrumbState: [],
      canOrder: false,
      breadcrumbColor: "#2E97CF",
      horizontalBoxColor: "",
      verticalBoxColor: "",
      multipleBoxColor: "",
      listBoxColor: "",
      colorCreatedAt: "",
      colorUpdatedAt: "",
      colorCreationdate: "",
      colorAZ: "",
      colorZA: "",
      colorType: "",
      paginationColor: {
        20: this.props.limit === 20 ? "#eaeaea" : "",
        40: this.props.limit === 40 ? "#eaeaea" : "",
        60: this.props.limit === 60 ? "#eaeaea" : "",
        80: this.props.limit === 80 ? "#eaeaea" : "",
        100: this.props.limit === 100 ? "#eaeaea" : ""
      },
      iconPaginationColor: {
        20: this.props.limit === 20,
        40: this.props.limit === 40,
        60: this.props.limit === 60,
        80: this.props.limit === 80,
        100: this.props.limit === 100
      },
      newFolderName: "",
      folderAction: "",
      editAction: "",
      showFolderManage: false,
      showCreateFolder: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
      canMove: false,
      canShare: false,
      canDownload: false,
      iconCreatedAt: false,
      iconUpdatedAt: false,
      iconCreationdate: false,
      iconAZ: false,
      iconZA: false,
      iconType: false
    };
  }

  componentDidMount() {
    const {
      folderselect,
      newColor,
      activeView,
      orderBy,
      user,
      newMatrix,
      workclient,
      keyCollection
    } = this.props;

    if (user && user.clientRole !== "admin" && user.role !== "admin") {
      this.setState({
        canCreate: getNewPermission(folderselect, newMatrix, "createFolder"),
        canEdit: getNewPermission(folderselect, newMatrix, "editFolder"),
        canDelete: getNewPermission(folderselect, newMatrix, "deleteFolder"),
        canMove: getNewPermission(folderselect, newMatrix, "moveFolder"),
        canShare: getNewPermission(folderselect, newMatrix, "shareFolder"),
        canDownload: getNewPermission(folderselect, newMatrix, "download")
      });
    } else if (user && (user.clientRole === "admin" || user.role === "admin")) {
      this.setState({
        canCreate: true,
        canEdit: true,
        canDelete: true,
        canMove: true,
        canShare: true,
        canDownload: true
      });
    }

    if (folderselect && keyCollection !== "assetsPublicShared") {
      this.props.getBreadCrumbsByClient(workclient, folderselect);
    }

    //Como se montaran los 'botones' de la vista horiz, list o vert por defecto
    this.handleCanOrder();
    this.handleActive({ orderBy: orderBy });
    if (newColor) {
      this.setState({
        breadcrumbColor: newColor
      });
    }
    if (activeView === "horizontal") {
      this.setState({
        verticalBoxColor: "#eaeaea",
        horizontalBoxColor: "#2E97CF",
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (activeView === "vertical") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#2E97CF",
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (activeView === "multiple") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#2E97CF",
        listBoxColor: "#eaeaea"
      });
    } else if (activeView === "list") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#2E97CF"
      });
    }
    //Como se montaran los 'botones' de la vista horiz, list o vert si anteriormente se modifico el color
    if (newColor && activeView === "vertical") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: newColor,
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (newColor && activeView === "horizontal") {
      this.setState({
        horizontalBoxColor: newColor,
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (newColor && activeView === "multiple") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: newColor,
        listBoxColor: "#eaeaea"
      });
    } else if (newColor && activeView === "list") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#eaeaea",
        listBoxColor: newColor
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      folderselect,
      newColor,
      activeView,
      limit,
      breadcrumb,
      newMatrix,
      user
    } = this.props;
    const { iconPaginationColor } = this.state;

    if (prevProps.limit !== limit) {
      this.setState({
        paginationColor: { [limit]: "#eaeaea" },
        iconPaginationColor: {
          [limit]: iconPaginationColor[limit]
            ? iconPaginationColor[limit]
            : true
        }
      });
    }

    if (prevProps.folderselect !== folderselect) {
      this.setState({
        showFolderManage: false
      });

      if (user && user.clientRole !== "admin" && user.role !== "admin") {
        this.setState({
          canCreate: getNewPermission(folderselect, newMatrix, "createFolder"),
          canEdit: getNewPermission(folderselect, newMatrix, "editFolder"),
          canDelete: getNewPermission(folderselect, newMatrix, "deleteFolder"),
          canMove: getNewPermission(folderselect, newMatrix, "moveFolder"),
          canShare: getNewPermission(folderselect, newMatrix, "shareFolder"),
          canDownload: getNewPermission(folderselect, newMatrix, "download")
        });
      } else if (
        user &&
        (user.clientRole === "admin" || user.role === "admin")
      ) {
        this.setState({
          canCreate: true,
          canEdit: true,
          canDelete: true,
          canMove: true,
          canShare: true,
          canDownload: true
        });
      }
    }

    if (prevProps.folderselect !== folderselect) {
      this.props.getBreadCrumbsByClient(this.props.workclient, folderselect);
    }

    if (prevProps.breadcrumb !== breadcrumb) {
      this.setState({
        breadcrumbState: getBreadCrumbs(folderselect)
      });
    }

    if (prevProps.newColor !== newColor) {
      this.setState({
        breadcrumbColor: newColor
      });
    }
    if (prevProps.newColor !== newColor && activeView === "vertical") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: newColor,
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (prevProps.newColor !== newColor && activeView === "horizontal") {
      this.setState({
        horizontalBoxColor: newColor,
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (prevProps.newColor !== newColor && activeView === "multiple") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea",
        multipleBoxColor: newColor
      });
    } else if (prevProps.newColor !== newColor && activeView === "list") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#eaeaea",
        listBoxColor: newColor
      });
    }
  }

  handleActiveView = type => {
    const { keyCollection, newColor } = this.props;
    this.props.setActiveView(keyCollection, type);
    this.props.unsetSelectItem(keyCollection);
    // Al clickear un 'boton' Horiz, List o Vert, cambiara de color segun corresponda, y dejara el otro en gris
    // (Evaluara si el color que debe mostrar es el que esta por defecto o el elegido en el colorpicker)
    if (!newColor && type === "vertical") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#2E97CF",
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (!newColor && type === "horizontal") {
      this.setState({
        horizontalBoxColor: "#2E97CF",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (!newColor && type === "multiple") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#2E97CF",
        listBoxColor: "#eaeaea"
      });
    } else if (!newColor && type === "list") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#2E97CF"
      });
    } else if (newColor && type === "vertical") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: newColor,
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (newColor && type === "horizontal") {
      this.setState({
        horizontalBoxColor: newColor,
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#eaeaea",
        listBoxColor: "#eaeaea"
      });
    } else if (newColor && type === "multiple") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: newColor,
        listBoxColor: "#eaeaea"
      });
    } else if (newColor && type === "list") {
      this.setState({
        horizontalBoxColor: "#eaeaea",
        verticalBoxColor: "#eaeaea",
        multipleBoxColor: "#eaeaea",
        listBoxColor: newColor
      });
    }
  };

  handleActivateMultipleOptions = () => {
    const { activeView, dataChecked, keyCollection } = this.props;

    if (activeView === "multiple" && dataChecked && dataChecked.length > 0) {
      this.props.activateMutipleSelectFunctions(keyCollection);
    }
  };

  handleCanOrder = () => {
    const { keyCollection } = this.props;

    if (keyCollection === "assetsExplore" || keyCollection === "searcher") {
      this.setState({
        canOrder: true
      });
    }
  };

  handleActive = orderBy => {
    if (orderBy === "-createdAt") {
      this.setState({
        colorCreatedAt: "#eaeaea",
        colorUpdatedAt: "",
        colorCreationdate: "",
        colorAZ: "",
        colorZA: "",
        colorType: "",
        iconCreatedAt: true,
        iconUpdatedAt: false,
        iconCreationdate: false,
        iconAZ: false,
        iconZA: false,
        iconType: false
      });
    } else if (orderBy === "-updatedAt") {
      this.setState({
        colorCreatedAt: "",
        colorUpdatedAt: "#eaeaea",
        colorCreationdate: "",
        colorAZ: "",
        colorZA: "",
        colorType: "",
        iconCreatedAt: false,
        iconUpdatedAt: true,
        iconCreationdate: false,
        iconAZ: false,
        iconZA: false,
        iconType: false
      });
    } else if (orderBy === "createdAt") {
      this.setState({
        colorCreatedAt: "",
        colorUpdatedAt: "",
        colorCreationdate: "#eaeaea",
        colorAZ: "",
        colorZA: "",
        colorType: "",
        iconCreatedAt: false,
        iconUpdatedAt: false,
        iconCreationdate: true,
        iconAZ: false,
        iconZA: false,
        iconType: false
      });
    } else if (orderBy === "name") {
      this.setState({
        colorCreatedAt: "",
        colorUpdatedAt: "",
        colorCreationdate: "",
        colorAZ: "#eaeaea",
        colorZA: "",
        colorType: "",
        iconCreatedAt: false,
        iconUpdatedAt: false,
        iconCreationdate: false,
        iconAZ: true,
        iconZA: false,
        iconType: false
      });
    } else if (orderBy === "-name") {
      this.setState({
        colorCreatedAt: "",
        colorUpdatedAt: "",
        colorCreationdate: "",
        colorAZ: "",
        colorZA: "#eaeaea",
        colorType: "",
        iconCreatedAt: false,
        iconUpdatedAt: false,
        iconCreationdate: false,
        iconAZ: false,
        iconZA: true,
        iconType: false
      });
    } else if (orderBy === "extension") {
      this.setState({
        colorCreatedAt: "",
        colorUpdatedAt: "",
        colorCreationdate: "",
        colorAZ: "",
        colorZA: "",
        colorType: "#eaeaea",
        iconCreatedAt: false,
        iconUpdatedAt: false,
        iconCreationdate: false,
        iconAZ: false,
        iconZA: false,
        iconType: true
      });
    }
  };

  handleShowCRUD = () => {
    const { showFolderManage } = this.state;
    this.setState({
      showFolderManage: !showFolderManage
    });
  };

  handleHideCRUD = () => {
    this.setState({
      showFolderManage: false
    });
  };

  handleHideCRUDFolder = () => {
    this.setState({
      showCreateFolder: false,
      folderAction: ""
    });
  };

  handleShowCRUDFolder = (action, editActionProp) => {
    const { workclient } = this.props;

    if (workclient)
      this.setState({
        showCreateFolder: true,
        folderAction: action,
        editAction: editActionProp ? editActionProp : ""
      });
  };

  render() {
    const {
      breadcrumbState,
      breadcrumbColor,
      horizontalBoxColor,
      verticalBoxColor,
      listBoxColor,
      canOrder,
      colorCreatedAt,
      colorUpdatedAt,
      colorCreationdate,
      colorAZ,
      colorZA,
      colorType,
      showCreateFolder,
      folderAction,
      showFolderManage,
      canCreate,
      canDelete,
      canEdit,
      canMove,
      canShare,
      canDownload,
      iconCreatedAt,
      iconUpdatedAt,
      iconCreationdate,
      iconAZ,
      iconZA,
      iconType,
      iconPaginationColor,
      editAction
    } = this.state;
    const {
      title,
      activeView,
      keyCollection,
      webToken,
      sharedBreadCrumb,
      workclient,
      page,
      folderselect,
      orderBy,
      limit,
      intl,
      password,
      userWhoShared,
      location,
      user
    } = this.props;
    const titleBreadcrumbs = [...breadcrumbState].pop();
    let titleDrawerFolder = "";
    if (folderAction === "create")
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="create_folder" />
        </div>
      );
    else if (folderAction === "edit")
      if (editAction === "rename") {
        titleDrawerFolder = (
          <div className="crudfoldertitle">
            <FormattedMessage id="rename" />
          </div>
        );
      }
    if (editAction === "move") {
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="move_asset" />
        </div>
      );
    }
    if (editAction === "tags_protocol") {
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="tags_protocol" />
        </div>
      );
    } else if (folderAction === "delete")
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="delete_folder" />
        </div>
      );
    else if (folderAction === "move")
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="move_folder" />
        </div>
      );
    else if (folderAction === "share")
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="share_folder" />
        </div>
      );

    const isOperator = user && user.clientRole !== "admin";
    const byUser = userWhoShared
      ? intl.locale === "es"
        ? `por ${userWhoShared}`
        : `by ${userWhoShared}`
      : "";
    return (
      <React.Fragment>
        <div className="title-bar">
          <div
            className="container"
            style={{ borderLeftColor: breadcrumbColor }}
          >
            {title && (
              <span>
                {title}{" "}
                {keyCollection === "assetsPublicShared" &&
                sharedBreadCrumb.length === 0
                  ? byUser
                  : ""}{" "}
              </span>
            )}
            {!title && <span>{titleBreadcrumbs && titleBreadcrumbs.name}</span>}

            {!canCreate && !canEdit && !canDelete && !canMove && !canShare && (
              <Tooltip
                placement="bottom"
                title={intl.formatMessage({ id: "option_off" })}
              >
                {keyCollection === "assetsExplore" && (
                  <Button
                    ghost
                    onClick={this.handleShowCRUD}
                    onMouseEnter={this.handleClass}
                    size="small"
                    style={{ marginLeft: "5px" }}
                  >
                    <span style={{ fontSize: "13px" }}>
                      {intl.formatMessage({ id: "folder_management" })}
                    </span>
                  </Button>
                )}
              </Tooltip>
            )}
            {(canCreate || canEdit || canDelete || canMove || canShare) &&
              keyCollection === "assetsExplore" && (
                <Button
                  ghost
                  onClick={this.handleShowCRUD}
                  onMouseEnter={this.handleClass}
                  size="small"
                  style={{ marginLeft: "5px" }}
                >
                  <span style={{ fontSize: "13px" }}>
                    {intl.formatMessage({ id: "folder_management" })}
                  </span>
                </Button>
              )}

            {showFolderManage && (
              <ButtonGroup
                size="small"
                style={{ marginLeft: "5px", paddingTop: "7px" }}
                className="slide-in-left"
              >
                {canEdit && (
                  <Button
                    style={{
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      height: "24px"
                    }}
                    onClick={() => this.handleShowCRUDFolder("edit", "rename")}
                  >
                    {intl.formatMessage({ id: "rename" })}
                  </Button>
                )}
                {canEdit && (
                  <Button
                    style={{
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      height: "24px"
                    }}
                    onClick={() => this.handleShowCRUDFolder("edit", "move")}
                  >
                    {intl.formatMessage({ id: "move_asset" })}
                  </Button>
                )}
                {canEdit && (
                  <Button
                    style={{
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      height: "24px"
                    }}
                    onClick={() =>
                      this.handleShowCRUDFolder("edit", "tags_protocol")
                    }
                  >
                    {intl.formatMessage({ id: "tags_protocol" })}
                  </Button>
                )}
                {isOperator && !canEdit && canMove && (
                  <Button
                    style={{
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      height: "24px"
                    }}
                    onClick={() => this.handleShowCRUDFolder("move")}
                  >
                    {intl.formatMessage({ id: "move_asset" })}
                  </Button>
                )}
                {canShare && (
                  <Button
                    style={{
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      height: "24px"
                    }}
                    onClick={() => this.handleShowCRUDFolder("share")}
                  >
                    {intl.formatMessage({ id: "shared_share" })}
                  </Button>
                )}
                {canCreate && (
                  <Button
                    style={{
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      height: "24px"
                    }}
                    onClick={() => this.handleShowCRUDFolder("create")}
                  >
                    {intl.formatMessage({ id: "create" })}
                  </Button>
                )}
                {canDelete && (
                  <Button
                    style={{
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      height: "24px"
                    }}
                    onClick={() => this.handleShowCRUDFolder("delete")}
                  >
                    {intl.formatMessage({ id: "delete_asset" })}
                  </Button>
                )}
                {canDownload && (
                  <Button
                    style={{
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      height: "24px"
                    }}
                    onClick={() => this.props.resumeDownload(folderselect)}
                  >
                    {intl.formatMessage({ id: "download_asset" })}
                  </Button>
                )}
              </ButtonGroup>
            )}
            {/*shared*/}
            <ul>
              {/* {keyCollection !== 'assetsPublicShared' &&
                <Tooltip placement="bottom" title='Seleccion Multiple'>
                  <li
                    className={activeView === 'multiple' ? 'active' : ''}
                    style={{ backgroundColor: multipleBoxColor }}
                    onClick={() => { this.handleActiveView('multiple') }}
                  >
                    {dataChecked && dataChecked.length > 0
                      ?
                      <Popconfirm
                        title="¿Quieres continuar con las opciones de seleccion multiple?"
                        onConfirm={() => { this.handleActivateMultipleOptions() }}
                        onCancel={() => this.props.multipleOptionsIsDone(keyCollection)}
                        okText="Continuar"
                        placement="left"
                        cancelText="Cancelar"
                      >
                        <Icon type="check-square"
                          style={{ color: 'white', verticalAlign: 'center', display: 'block', width: 14, margin: 5, float: 'left' }}
                        />
                      </Popconfirm>
                      :
                      <Icon type="minus-square"
                        style={{ color: 'white', verticalAlign: 'center', display: 'block', width: 14, margin: 5, float: 'left' }}
                      />}
                  </li>
                </Tooltip>} */}
              <div className="cHeaderContainer" style={{ marginRight: "8px" }}>
                <Tooltip
                  placement="top"
                  title={intl.formatMessage({ id: "horizontal_view" })}
                >
                  <li
                    className={activeView === "horizontal" ? "active" : ""}
                    style={{ backgroundColor: horizontalBoxColor }}
                    onClick={() => {
                      this.handleActiveView("horizontal");
                    }}
                  >
                    <img alt="asset" src="/images/icons/row-icon.svg" />
                  </li>
                </Tooltip>
                <Tooltip
                  placement="top"
                  title={intl.formatMessage({ id: "vertical_view" })}
                >
                  <li
                    className={activeView === "vertical" ? "active" : ""}
                    style={{ backgroundColor: verticalBoxColor }}
                    onClick={() => {
                      this.handleActiveView("vertical");
                    }}
                  >
                    <img alt="asset" src="/images/icons/group-icon.svg" />
                  </li>
                </Tooltip>
                <Tooltip
                  placement="top"
                  title={intl.formatMessage({ id: "list_view" })}
                >
                  <li
                    className={activeView === "list" ? "active" : ""}
                    style={{ backgroundColor: listBoxColor }}
                    onClick={() => {
                      this.handleActiveView("list");
                    }}
                  >
                    <img alt="asset" src="/images/icons/list-icon.svg" />
                  </li>
                </Tooltip>
                {canOrder && (
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "sort_assets" })}
                  >
                    <li>
                      <img alt="asset" src="/images/icons/order-icon.svg" />
                      <ul>
                        <li
                          className={orderBy === "createdAt" ? "active" : ""}
                          style={{
                            backgroundColor: colorCreationdate,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handleOrderBy(
                              keyCollection,
                              workclient,
                              "createdAt",
                              folderselect,
                              page,
                              limit
                            );
                            this.handleActive("createdAt");
                          }}
                        >
                          <span
                            key="3"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            {intl.formatMessage({ id: "upload_date" })}{" "}
                            <Icon type="arrow-up" />
                          </span>
                          {iconCreationdate && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={orderBy === "-createdAt" ? "active" : ""}
                          style={{
                            backgroundColor: colorCreatedAt,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handleOrderBy(
                              keyCollection,
                              workclient,
                              "-createdAt",
                              folderselect,
                              page,
                              limit
                            );
                            this.handleActive("-createdAt");
                          }}
                        >
                          <span
                            key="1"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            {intl.formatMessage({ id: "upload_date" })}{" "}
                            <Icon type="arrow-down" />
                          </span>
                          {iconCreatedAt && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={orderBy === "-updatedAt" ? "active" : ""}
                          style={{
                            backgroundColor: colorUpdatedAt,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handleOrderBy(
                              keyCollection,
                              workclient,
                              "-updatedAt",
                              folderselect,
                              page,
                              limit
                            );
                            this.handleActive("-updatedAt");
                          }}
                        >
                          <span
                            key="2"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            {intl.formatMessage({ id: "last_modified" })}
                          </span>
                          {iconUpdatedAt && (
                            <Icon type="check" style={{ marginLeft: "20px" }} />
                          )}
                        </li>

                        <li
                          className={orderBy === "name" ? "active" : ""}
                          style={{
                            backgroundColor: colorAZ,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handleOrderBy(
                              keyCollection,
                              workclient,
                              "name",
                              folderselect,
                              page,
                              limit
                            );
                            this.handleActive("name");
                          }}
                        >
                          <span
                            key="4"
                            title="name"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            A - Z
                          </span>
                          {iconAZ && (
                            <Icon
                              type="check"
                              style={{ marginLeft: "120px" }}
                            />
                          )}
                        </li>
                        <li
                          className={orderBy === "-name" ? "active" : ""}
                          style={{
                            backgroundColor: colorZA,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handleOrderBy(
                              keyCollection,
                              workclient,
                              "-name",
                              folderselect,
                              page,
                              limit
                            );
                            this.handleActive("-name");
                          }}
                        >
                          <span
                            key="5"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            Z - A
                          </span>
                          {iconZA && (
                            <Icon
                              type="check"
                              style={{ marginLeft: "120px" }}
                            />
                          )}
                        </li>
                        <li
                          className={orderBy === "extension" ? "active" : ""}
                          style={{
                            backgroundColor: colorType,
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handleOrderBy(
                              keyCollection,
                              workclient,
                              "extension",
                              folderselect,
                              page,
                              limit
                            );
                            this.handleActive("extension");
                          }}
                        >
                          <span
                            key="5"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            {intl.formatMessage({ id: "asset_type" })}
                          </span>
                          {iconType && (
                            <Icon type="check" style={{ marginLeft: "60px" }} />
                          )}
                        </li>
                      </ul>
                    </li>
                  </Tooltip>
                )}
                {keyCollection === "searcher" && (
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "items_per_page" })}
                  >
                    <li>
                      <Icon
                        type="more"
                        style={{
                          color: "white",
                          fontSize: "20px",
                          marginTop: "2px",
                          display: "inline-block",
                          width: "100%"
                        }}
                      />
                      <ul style={{ width: "100px", marginLeft: "100px" }}>
                        <li
                          className={limit === 20 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[20],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handlePaginationNumber(
                              keyCollection,
                              workclient,
                              page,
                              20,
                              orderBy,
                              folderselect
                            );
                            this.handleActive();
                          }}
                        >
                          <span
                            key="1"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            20
                          </span>
                          {iconPaginationColor[20] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={limit === 40 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[40],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handlePaginationNumber(
                              keyCollection,
                              workclient,
                              page,
                              40,
                              orderBy,
                              folderselect
                            );
                            this.handleActive();
                          }}
                        >
                          <span
                            key="2"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            40
                          </span>
                          {iconPaginationColor[40] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={limit === 60 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[60],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handlePaginationNumber(
                              keyCollection,
                              workclient,
                              page,
                              60,
                              orderBy,
                              folderselect
                            );
                            this.handleActive();
                          }}
                        >
                          <span
                            key="3"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            60
                          </span>
                          {iconPaginationColor[60] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={limit === 80 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[80],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handlePaginationNumber(
                              keyCollection,
                              workclient,
                              page,
                              80,
                              orderBy,
                              folderselect
                            );
                            this.handleActive();
                          }}
                        >
                          <span
                            key="4"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            80
                          </span>
                          {iconPaginationColor[80] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                        <li
                          className={limit === 100 ? "active" : ""}
                          style={{
                            backgroundColor: this.state.paginationColor[100],
                            cursor: "pointer"
                          }}
                          onClick={() => {
                            this.props.handlePaginationNumber(
                              keyCollection,
                              workclient,
                              page,
                              100,
                              orderBy,
                              folderselect
                            );
                            this.handleActive();
                          }}
                        >
                          <span
                            key="5"
                            style={{
                              color: "#337ab7",
                              backgroundColor: "transparent",
                              boxSizing: "border-box",
                              textDecoration: "none",
                              fontSize: 14,
                              marginTop: "-5px"
                            }}
                          >
                            100
                          </span>
                          {iconPaginationColor[100] && (
                            <Icon type="check" style={{ marginLeft: "28px" }} />
                          )}
                        </li>
                      </ul>
                    </li>
                  </Tooltip>
                )}
              </div>
            </ul>
            {keyCollection !== "assetsPublicShared" ? (
              <div className="miga">
                {breadcrumbState.length > 1 &&
                  breadcrumbState
                    .filter(r => r.id !== titleBreadcrumbs.id)
                    .map((r, k) => (
                      <Link
                        to={
                          r.name === "Bunkers"
                            ? `/home`
                            : `/home/explore/${r.id}`
                        }
                        onClick={() => {
                          this.props.setSelectedFolderExplore(r.id);
                        }}
                        key={k}
                        style={{
                          fontSize: 13,
                          cursor: "pointer",
                          color: "#2E97CF"
                        }}
                      >
                        {r.name}/
                      </Link>
                    ))}
              </div>
            ) : (
              <div className="miga">
                {/* Inicio en breadcrumb cuando el asset es público */}
                {sharedBreadCrumb[0] ? (
                  <a
                    href={`/archivos-compartidos${location.search}`}
                    style={{
                      fontSize: 13,
                      cursor: "pointer",
                      color: "#2E97CF"
                    }}
                  >
                    {`${intl.formatMessage({ id: "homeBreadcrumb" })}/`}
                  </a>
                ) : (
                  ""
                )}
                {/* Dibuja el resto del breadcrumb */}
                {sharedBreadCrumb.length > 1 &&
                  sharedBreadCrumb
                    .filter(f => f.name !== title)
                    .map((r, k) => (
                      <span
                        key={r.id}
                        onClick={() =>
                          this.props.navigatePublicSharedFolder(
                            webToken,
                            r.id,
                            r.name,
                            password
                          )
                        }
                        style={{
                          cursor: "pointer",
                          color: "#2E97CF",
                          fontSize: 13
                        }}
                      >
                        {r.name}/
                      </span>
                    ))}
              </div>
            )}
          </div>
        </div>
        <Modal
          // title={"MENSAJE DE PRUEBA"}
          width={getWithDrawer()}
          onCancel={this.handleHideCRUDFolder}
          onClose={this.handleHideCRUDFolder}
          closeIcon={<img src={CloseIcon} alt={"icon close"} />}
          destroyOnClose={true}
          visible={showCreateFolder}
          keyboard={true}
          footer={null}
          centered
          className="delete-modal"
        >
          <div className="delete-modal-title">{titleDrawerFolder}</div>
          <CRUDFolder
            handleHideCRUDFolder={this.handleHideCRUDFolder}
            action={folderAction}
            canMove={canMove}
            canEdit={canEdit}
            editAction={editAction}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps;
  let object;
  switch (keyCollection) {
    case "assetsRoot":
      object = {
        isFetching: state.assetsRoot.isFetching,
        data: state.assetsRoot.data,
        dataChecked: state.assetsRoot.data.filter(r => r.isCheckMultiple),
        folderselect: state.assetsRoot.folderselect,
        error: state.assetsRoot.error,
        activeView: state.assetsRoot.activeView
      };
      break;
    case "assetsLastUploads":
      object = {
        isFetching: state.assetsLastUploads.isFetching,
        data: state.assetsLastUploads.data,
        dataChecked: state.assetsLastUploads.data.filter(
          r => r.isCheckMultiple
        ),
        folderselect: state.assetsLastUploads.folderselect,
        error: state.assetsLastUploads.error,
        activeView: state.assetsLastUploads.activeView
      };
      break;
    case "assetsShared":
      object = {
        isFetching: state.assetsShared.isFetching,
        data: state.assetsShared.data,
        dataChecked: state.assetsShared.data.filter(r => r.isCheckMultiple),
        folderselect: state.assetsShared.folderselect,
        error: state.assetsShared.error,
        activeView: state.assetsShared.activeView,
        orderBy: state.assetsExplore.orderBy
      };
      break;
    case "assetsFavorites":
      object = {
        isFetching: state.assetsFavorites.isFetching,
        data: state.assetsFavorites.data,
        dataChecked: state.assetsFavorites.data.filter(r => r.isCheckMultiple),
        folderselect: state.assetsFavorites.folderselect,
        error: state.assetsFavorites.error,
        activeView: state.assetsFavorites.activeView
      };
      break;
    case "assetsExplore":
      object = {
        isFetching: state.assetsExplore.isFetching,
        data: state.assetsExplore.data,
        dataChecked: state.assetsExplore.data.filter(r => r.isCheckMultiple),
        folderselect: state.assetsExplore.folderselect,
        error: state.assetsExplore.error,
        activeView: state.assetsExplore.activeView,
        page: state.assetsExplore.page,
        orderBy: state.assetsExplore.orderBy,
        limit: state.assetsExplore.limit
      };
      break;
    case "searcher":
      object = {
        isFetching: state.searcher.isFetching,
        data: state.searcher.data,
        dataChecked: state.searcher.data.filter(r => r.isCheckMultiple),
        folderselect: state.searcher.folderselect,
        error: state.searcher.error,
        activeView: state.searcher.activeView,
        page: state.searcher.page,
        searchText: state.searcher.searchText,
        searchType: state.searcher.searchType,
        orderBy: state.searcher.orderBy,
        limit: state.searcher.limit
      };
      break;
    case "assetsPublicShared":
      object = {
        isFetching: state.assetsPublicShared.isFetching,
        data: state.assetsPublicShared.data,
        folderselect: state.assetsPublicShared.folderselect,
        error: state.assetsPublicShared.error,
        activeView: state.assetsPublicShared.activeView,
        webToken: state.assetsPublicShared.webToken,
        sharedBreadCrumb: state.assetsPublicShared.sharedBreadCrumb,
        accessToken: state.assetsPublicShared.accessToken
      };
      break;
    default:
      object = {};
      break;
  }

  return {
    ...object,
    workclient: state.client.workclient,
    width: state.app.width,
    user: state.authUser.user,
    breadcrumb: state.client.breadcrumb,
    isFetchingBreadcrumb: state.client.isFetching,
    matrix: state.group.matrix,
    newMatrix: state.group.newMatrix,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF"
  };
};

const mapDispatchToProps = {
  setActiveView,
  unsetSelectItem,
  navigatePublicSharedFolder,
  handleOrderBy,
  handlePaginationNumber,
  activateMutipleSelectFunctions,
  multipleOptionsIsDone,
  resumeDownload,
  setSelectedFolderExplore,
  getBreadCrumbsByClient
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionHeader))
);
